import { render, staticRenderFns } from "./yiRed.vue?vue&type=template&id=e774ee64&scoped=true&"
import script from "./yiRed.vue?vue&type=script&lang=js&"
export * from "./yiRed.vue?vue&type=script&lang=js&"
import style0 from "./yiRed.vue?vue&type=style&index=0&id=e774ee64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e774ee64",
  null
  
)

export default component.exports